import type { ModificationsFeatureConfig } from '../../../types/features/ModificationsFeatureConfig';

export const modifications: ModificationsFeatureConfig = {
    showContractUpgrade: false,
};
